module.exports = __webpack_public_path__ + "static/media/flu_over_cuckoo_nest.2ee378d3.png";